import CogLarge from './cogLarge';
import CogSmall from './cogSmall';
import LaptopImage from './laptopImage';
import Logo from './logo';
import Pointer from './pointer';
import ScrollIcon from './scrollIcon';

const svg = { CogLarge, CogSmall, LaptopImage, Logo, Pointer, ScrollIcon };
export default svg;
